import React, { useState, useEffect } from 'react';
import { Badge, Tooltip, OverlayTrigger } from "react-bootstrap";
import '../../Forum.css'; // Include this CSS file for custom styles
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';

const LikeButton = ({ initialLikes, postId, userId }) => {
    const [likes, setLikes] = useState(initialLikes);
    const [liked, setLiked] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);

    useEffect(() => {
        fetchIsLiked(userId, postId);
    }, [userId, postId]);

    const fetchIsLiked = (userId, postId) => {
        fetch(`${process.env.REACT_APP_API_URL}/hasLiked/${userId}/${postId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                setLiked(data); // Assuming `data` is a boolean indicating whether the post is liked or not
            })
            .catch((error) => {
                console.error('Error checking if liked:', error);
            });
    };

    const handleLike = (userId, postId) => {
        fetch(`${process.env.REACT_APP_API_URL}/like`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                user_id: userId,
                post_id: postId,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                setLikes(likes + 1);
                setLiked(true);
            })
            .catch((error) => {
                console.error('Error liking post:', error);
            });
    };

    const handleUnlike = (userId, postId) => {
        fetch(`${process.env.REACT_APP_API_URL}/unlike`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                user_id: userId,
                post_id: postId,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                setLikes(likes - 1);
                setLiked(false);
            })
            .catch((error) => {
                console.error('Error unliking post:', error);
            });
    };

    const handleToggleLike = () => {
        if (isProcessing) return;

        if (userId === "ANONYMOUS") {
            NotificationManager.error('Trebuie să fi conectat pentru a aprecia postarea.');
            return;
        }

        setIsProcessing(true);

        if (liked) {
            handleUnlike(userId, postId);
        } else {
            handleLike(userId, postId);
        }

        setIsProcessing(false);
    };

    return (
        <>
            <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="copy-link-tooltip">Apreciaza postarea</Tooltip>}
            >
                <Badge
                    bg={liked ? "success" : "lightGray"}
                    className="me-2 badge-button flex-grow-1 text-center"
                    onClick={handleToggleLike}
                    style={{ cursor: 'pointer', backgroundColor: liked ? 'lightgreen' : 'lightblue' }}
                >
                    {likes} <i className={`bi bi-hand-thumbs-${liked ? 'up-fill' : 'up'}`}></i>
                </Badge>
            </OverlayTrigger>
            <NotificationContainer />
        </>
    );
};

export default LikeButton;
